import { ApolloClient, InMemoryCache } from "@apollo/client";
import buildGraphQLProvider from 'ra-data-graphql-simple';
import {appBuildQuery} from "./appBuildQuery";


export const createApolloClient = ({ uri, apiToken, orgId }) => new ApolloClient({
    // Provide required constructor fields
    cache: new InMemoryCache({ resultCaching: false }),
    uri,
    headers: {
        Authorization: `Bearer ${apiToken}`,
        'x-org-id': orgId
    },

    // Provide some optional constructor fields
    name: 'react-admin-client',
    version: '1.3',
    queryDeduplication: false,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
})

const appDataProvider = (defaultDataProvider) =>
  async (fetchType, resource, params) => {
    const data = await defaultDataProvider(fetchType, resource, params);

    return data;
  }

export const buildAppGraphQLProvider = ({ client }) => buildGraphQLProvider({ client, buildQuery: appBuildQuery })
  .then(defaultDataProvider => appDataProvider(defaultDataProvider))
;


